<template>
  <div class="app-container">
    <el-card>
      <div class="topbar">
        <div>
          <el-select v-model="useType" @change="platformChange()">
            <el-option :value="0" label="Android"></el-option>
            <el-option :value="1" label="iOS"></el-option>
            <el-option :value="2" label="pc端"></el-option>
            <el-option :value="3" label="仪器端"></el-option>
          </el-select>
        </div>
        <div>
          <el-button type="success" size="small" @click="publicVersion()">发布新版本</el-button>
        </div>

      </div>

      <el-table v-loading="loading"
                :data="versionList"
                :header-cell-style="{ background: '#F5F7FA' }"
                style="width: 100%; margin-bottom: 20px"
                border
      >
        <el-table-column label="版本号" width="70" prop="versionCode" align="center"></el-table-column>
        <el-table-column label="版本名" width="100" prop="versionName" align="center"></el-table-column>
        <el-table-column label="更新简述" prop="updateLog" align="center"></el-table-column>
        <!--        <el-table-column label="详述" prop="describe" align="center"></el-table-column>-->
        <el-table-column label="强制更新" width="100" prop="isForced" align="center">
          <template #default="scope">
            <el-switch disabled :value="scope.row.isForced"></el-switch>
          </template>
        </el-table-column>
        <el-table-column label="创建时间" width="180" prop="createTime" align="center">
          <template #default="scope">
            {{ scope.row.createTime | formatDateTime }}
          </template>
        </el-table-column>
        <el-table-column label="操作" align="center" width="150">
          <template #default="scope">
            <el-link class="linkPadding" type="primary" size="small" @click="download(scope.row.downloadUrl)">下载
            </el-link>
            <el-link class="linkPadding" type="primary" size="small" @click="copyLink(scope.row.downloadUrl)">复制链接
            </el-link>
            <el-link class="linkPadding" type="primary" size="small"
                     @click="viewCompatibleVersions(scope.row)">查看兼容版本
            </el-link>
          </template>

        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
          background
          :total="pageOpt.total"
          :page-size="pageOpt.pageSize"
          :current-page="pageOpt.curPage"
          @current-change="currentChange"
      />

    </el-card>

    <el-dialog :visible.sync="showCompatibleVersionDlg" title="兼容版本" width="60%">
      <div style="width: 100%;height: 40vh;overflow: auto;">
        <el-table v-loading="getCompatibleListLoading"
                  :data="compatibleVersionList"
                  :header-cell-style="{ background: '#F5F7FA' }"
                  style="width: 100%; margin-bottom: 20px;"
                  border>
          <el-table-column prop="versionName" label="版本名" align="center" width="100"></el-table-column>
          <el-table-column prop="updateLog" label="更新简述" align="center"></el-table-column>
        </el-table>
      </div>

    </el-dialog>
  </div>
</template>

<script>
import {getVersionList, getCompatibleList} from "@/api/system/AppVersion/AppVersion";
import {handleRes, handleResWithReturn} from "@/utils/handleRes";
import {copy2Clipboard} from "@/utils/clipboard";
import {downloadFile} from "@/utils/OSSUpload";

export default {
  name: "index",
  data() {
    return {
      searchValue: "",
      loading: false,
      useType: 0,
      versionList: [],
      pageOpt: {
        curPage: 0,
        total: 0,
        pageSize: 10
      },

      //记录当前选中版本，用于查看兼容版本
      getCompatibleListLoading: false,
      curVersionInfo: {},
      showCompatibleVersionDlg: false,
      compatibleVersionList: []
    }
  },
  created() {
    this.platformChange()
  },
  methods: {
    platformChange() {
      this.pageOpt.curPage = 1;
      this.searchValue = ""
      this.getVersionList();
    },
    getVersionList() {
      this.loading = true
      let para = {
        keyWord: this.searchValue,
        pageNumber: this.pageOpt.curPage,
        pageSize: this.pageOpt.pageSize,
        where: [{
          "field": "useType",
          "value": this.useType,
          "op": "equal"
        }]
      }

      getVersionList(para).then(res => {
        handleRes(res, () => {
          this.pageOpt.total = res.data.total
          this.versionList = res.data.rows
        })
        this.loading = false
      })
    },
    publicVersion() {
      this.$router.push({
        path: 'publicVersion',
        query: {
          useType: `${this.useType}`,
        }
      })
    },
    currentChange(curPage) {
      this.pageOpt.curPage = curPage
      this.getVersionList()
    },
    copyLink(url) {
      copy2Clipboard(url)
      this.$message("复制成功")
    },
    download(url) {
      downloadFile(url)
    },
    viewCompatibleVersions(versionInfo) {
      this.curVersionInfo = versionInfo
      this.compatibleVersionList = []
      this.getCompatibleList()
      this.showCompatibleVersionDlg = true;
    },
    async getCompatibleList() {
      this.getCompatibleListLoading = true;
      let para = {
        "versionCode": this.curVersionInfo.versionCode,
        "type": this.curVersionInfo.useType,
      }
      let res = await getCompatibleList(para)
      if (handleResWithReturn(res)) {
        this.compatibleVersionList = res.data
      }
      this.getCompatibleListLoading = false;
    }
  }
}
</script>

<style scoped>
.linkPadding {
  /*padding-left: 20px;*/
  margin-right: 10px;
}
</style>